import { SmartReportDivision, SmartReportsItem } from 'models/projectReports'

/**
 * Predicates for reading a generated-report response. They inspect what the server
 * sent back, not what is cached — see {@link useReportsCache} for the cache itself.
 */

/**
 * True when a report response carries no usable rows.
 *
 * The server signals "nothing here" two ways: an empty list, or rows with a null
 * `divisionGroupId` — the latter despite `SmartReportsItem` typing that field as a
 * plain `string`.
 */
export const isReportDataEmpty = (
    reportRows: SmartReportsItem[] | undefined
): boolean =>
    (reportRows ?? []).some((row) => row.divisionGroupId === null) ||
    (reportRows ?? []).length === 0

/**
 * True when a response has something worth caching.
 *
 * Deliberately **not** the inverse of {@link isReportDataEmpty}: divisions alone are
 * enough to be worth keeping, even with no usable rows.
 */
export const hasUsableReportData = (
    reportRows: SmartReportsItem[] | undefined,
    reportRowDivisions: SmartReportDivision[] | undefined
): boolean =>
    (reportRows ?? []).some((row) => row.divisionGroupId !== null) ||
    (reportRowDivisions ?? []).length > 0
